<template>
    <div class="account-page" style="height: 100vh;">
   <!-- Main Wrapper -->
   <div class="main-wrapper">
    <div class="account-content">

        <div class="container">

            <!-- Account Logo -->
            <div class="account-logo">
                <router-link to="/index"><img src="@/assets/img/dkl.png" alt="Datenschutzkanzlei Lenz"></router-link>
            </div>
            <!-- /Account Logo -->

            <div class="account-box">
                <div class="account-wrapper">
                    <h3 class="account-title">Mandant Wählen</h3>
                    <p class="account-subtitle">Zugriff auf Mandant DSMS Tool</p>

                    <!-- Account Form -->
                      <div class="form-group">
                          <label>Mandant</label>
                        <select id="mandanten_list"></select>
                      </div>
                      <div class="form-group text-center">
                          <button class="btn btn-primary account-btn" type="button" @click="setMandant">Weiter</button>
                      </div>
                    <!-- /Account Form -->

                </div>
            </div>
        </div>
    </div>
</div>
<!-- /Main Wrapper -->
</div>
<!-- /Main Wrapper -->
</template>
<script>
import {mapActions, mapMutations} from 'vuex'
  import {baseURL, crmURL, service} from '@/utils/request.js';
  import {getDepartments, getSystems, getDataTypes, getPersonGroups, getSuppliers} from "@/utils";

  export default {
    data() {
      return {
        token: '',
        dsms_user: '',
        customer: '',
        nextUrl: '',
        accountId: '',
        crmID: '',
      }
    },
    async mounted() { // token=${token}&user=${dsms_user}&customer=${customerName}&next=${url}
      this.token = this.$route.query.token
      this.dsms_user = this.$route.query.user
      this.customer = this.$route.query.customer
      this.nextUrl = this.$route.query.next
      this.setAuthentication(true)
      this.setToken(this.token)
      await this.setUser(this.dsms_user)
      await this.getMandant(this.customer)
      await this.setMandant()
    },
    methods: {
      ...mapActions(['fetchAccountByShortName']),
      ...mapMutations({setToken: 'SET_TOKEN', setUsername: 'SET_USERNAME', setName: 'SET_NAME', setAuthentication: 'SET_AUTHENTICATION', setId: 'SET_ID', setMandantId: 'SET_ACCOUNT_ID', setCRMId: 'SET_CRM_ID'}),
      async getMandant(name) {
        await service.request({
          url: `/get_mandant_by_name/${this.customer}`,
          method: 'GET',
          responseType: 'json',
        }).then((response) => {
          this.accountId = response.data.id
          this.crmID = response.data.crm_id
        })
      },
      async setUser(username) {
        await service.request({
          url: `/get_user_info/${this.dsms_user}/`,
          method: 'GET',
          responseType: 'json',
        }).then((response) => {
          this.setId(response.data.id)
          this.setUsername(response.data.username)
          this.setName(response.data.name)
        })
      },
      async setMandant() {
        await service.request({
          url: `${crmURL}/company_by_name/?name=` + encodeURIComponent(this.customer),
          method: 'GET',
          responseType: 'json',
        }).then(response => {
          this.$store.commit('SET_ACCOUNT', {
            id: this.accountId,
            name: this.customer,
            address: response.data.company_detail.address,
            betreuer: response.data.company_detail.consultant,
            betriebsrat: response.data.company_detail.betriebsrat,
            email: response.data.company_detail.email,
            website: response.data.company_detail.website,
            dsb: response.data.company_detail.dsb,
            phone: response.data.company_detail.phone,
            restSubscription: null,
            crmID: this.crmID,
            dsko: response.data.company_detail.dsko,
            aufsichtsbehoerde: response.data.company_detail.aufsichtsbehoerde,
          })
        })
        await getSystems(this.accountId)
        await getDepartments(this.accountId)
        await getDataTypes(this.accountId)
        await getPersonGroups(this.accountId)
        await getSuppliers(this.accountId)
        this.$router.push({name: this.nextUrl})

      }
    }
  }
</script>
